import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Button,
  Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import { useDeleteApplicationDocs } from '@features/applicationsDocs/hooks/useDeleteApplicationDocs';

type DeleteDocumentModalProps = {
  handleClose: () => void;
  applicationId: number;
  documentId: number | null;
};

const DeleteDocumentModal: FC<DeleteDocumentModalProps> = ({
  handleClose,
  applicationId,
  documentId,
}) => {
  const [errorText, setErrorText] = useState('');

  const { deleteDocument, isDeletingApplicationDocument } =
    useDeleteApplicationDocs({
      setErrorText,
      applicationId,
    });

  const handleDelete = () =>
    deleteDocument(
      { documentId: documentId! },
      {
        onSuccess: () => {
          toast.success('Document deleted');
          handleClose();
        },
      },
    );

  return (
    <Dialog
      open={Boolean(documentId)}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Are you sure you want to delete this document?</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <LoadingButton
            variant="contained"
            loading={isDeletingApplicationDocument}
            onClick={handleDelete}
            color="error"
          >
            Yes, delete this document
          </LoadingButton>
          <Button color="secondary" variant="outlined" onClick={handleClose}>
            No, Go Back
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDocumentModal;
